/**
 * Reads the WISMO (order-status) kill switch. False when the setting is absent or disabled.
 *
 * @returns {boolean}
 */
const isWismoKillswitchEnabled = () => !!Sephora.configurationSettings?.genAIChatBotWISMO?.isEnabled;

/**
 * Whether this client can request the WISMO order-status card. Sent on chat requests so the
 * backend only returns order status to clients that opted in.
 *
 * @returns {boolean}
 */
const selectWismoEnabled = () => isWismoKillswitchEnabled();

export {
    selectWismoEnabled, isWismoKillswitchEnabled
};
